import { Action } from 'redux';

import { SetContentPermissions } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface SetContentPermissionsAction extends Action {
  content: IContentInfo[];
}

export function setContentPermissions(content: IContentInfo[]) {
  return {
    type: SetContentPermissions,
    content: content
  };
}

export const isSetWorkbookPermissionsAction = isActionFactory<SetContentPermissionsAction>(SetContentPermissions);
